var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoggedIn)?_c('v-btn',_vm._b({attrs:{"exact":"","icon":_vm.icon},on:{"click":_vm.logout}},'v-btn',_vm.$attrs,false),[_c('v-icon',[_vm._v("mdi-logout")]),(!_vm.icon)?_c('span',[_vm._v("Logout")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }